import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes';

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	// scrollBehavior () {
	// 	return { y: 0 }
	// }
	scrollBehavior (to, from, savedPosition) {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve({ x: 0, y: 0, behavior: 'smooth' })
			})
		})
	}
})

export default router
